import styled from "styled-components";

import { colors, typography } from "src/assets/styles/settings";

export const SummaryTableWrapper = styled.div`
  border: 1px solid ${colors.disabled};
  border-radius: 8px;
  position: relative;
  overflow-x: auto;

  &.is-collapsable {
    padding-bottom: 20px;
  }

  &.is-expanded {
    padding-bottom: 0px;
  }

  @media (max-width: 640px) {
    ::-webkit-scrollbar {
      height: 6px;
    }
  }
`;

export const SummaryTable = styled.table`
  color: ${colors.black_bekko};
  border-collapse: collapse;
  max-width: 100%;
  width: 100%;

  thead {
    @media (max-width: 640px) {
      white-space: normal !important;
    }
  }

  thead > tr > th {
    color: ${colors.black_bekko};
    background-color: ${colors.disabled};
    font-size: ${typography.font_size.base};
    font-weight: ${typography.font_weight.bold};
    line-height: ${typography.line_height};
    padding: 12px 16px;
    text-align: right;
    vertical-align: bottom;

    :first-child {
      text-align: left;
    }

    @media (max-width: 640px) {
      min-width: 110px;
      vertical-align: top;
    }
  }

  tbody > tr > td {
    border-bottom: 1px solid ${colors.disabled};
    padding: 16px 12px;
    text-align: right;

    :first-child {
      text-align: left;
    }
  }

  tbody > tr:last-child > td {
    border-bottom: 3px solid ${colors.disabled};

    .is-collapsable & {
      border-bottom: 0px;
    }
  }

  tfoot > tr > td {
    color: ${colors.black_bekko};
    font-size: ${typography.font_size.base};
    font-weight: ${typography.font_weight.bold};
    line-height: ${typography.line_height};
    padding: 12px 16px;
    text-align: right;
    text-transform: uppercase;
    vertical-align: bottom;

    :nth-last-child(-n + 2) {
      border-bottom: 1px solid ${colors.disabled};
    }
  }

  tfoot > tr:last-child > td:nth-last-child(-n + 2) {
    background-color: ${colors.disabled};
  }
`;

export const SummaryCurtain = styled.div`
  height: 50px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background-image: linear-gradient(rgba(255, 255, 255, 0.4) 5%, rgba(255, 255, 255, 0.7) 20%, #fff);

  span {
    font-weight: 700;
    color: ${colors.flip_orange};
    text-decoration: underline;
    cursor: pointer;
    position: absolute;
    bottom: 10px;
    right: 12px;
  }

  .is-expanded & {
    height: 30px;
    position: relative;
  }
`;
